// Currency utility for formatting prices with proper symbols
export const CURRENCIES = [
  {"code":"USD","name":"United States Dollar","symbol":"$"},
  {"code":"EUR","name":"Euro","symbol":"€"},
  {"code":"GBP","name":"British Pound Sterling","symbol":"£"},
  {"code":"JPY","name":"Japanese Yen","symbol":"¥"},
  {"code":"CNY","name":"Chinese Yuan","symbol":"¥"},
  {"code":"AUD","name":"Australian Dollar","symbol":"$"},
  {"code":"CAD","name":"Canadian Dollar","symbol":"$"},
  {"code":"CHF","name":"Swiss Franc","symbol":"CHF"},
  {"code":"NZD","name":"New Zealand Dollar","symbol":"$"},

  {"code":"NGN","name":"Nigerian Naira","symbol":"₦"},
  {"code":"ZAR","name":"South African Rand","symbol":"R"},
  {"code":"KES","name":"Kenyan Shilling","symbol":"KSh"},
  {"code":"UGX","name":"Ugandan Shilling","symbol":"USh"},
  {"code":"TZS","name":"Tanzanian Shilling","symbol":"TSh"},
  {"code":"GHS","name":"Ghanaian Cedi","symbol":"₵"},
  {"code":"XOF","name":"CFA Franc BCEAO","symbol":"CFA"},
  {"code":"XAF","name":"CFA Franc BEAC","symbol":"FCFA"},
  {"code":"MAD","name":"Moroccan Dirham","symbol":"د.م."},
  {"code":"EGP","name":"Egyptian Pound","symbol":"£"},
  {"code":"DZD","name":"Algerian Dinar","symbol":"د.ج"},
  {"code":"ETB","name":"Ethiopian Birr","symbol":"Br"},
  {"code":"AOA","name":"Angolan Kwanza","symbol":"Kz"},
  {"code":"BWP","name":"Botswana Pula","symbol":"P"},
  {"code":"MZN","name":"Mozambican Metical","symbol":"MT"},
  {"code":"RWF","name":"Rwandan Franc","symbol":"FRw"},

  {"code":"INR","name":"Indian Rupee","symbol":"₹"},
  {"code":"PKR","name":"Pakistani Rupee","symbol":"₨"},
  {"code":"BDT","name":"Bangladeshi Taka","symbol":"৳"},
  {"code":"LKR","name":"Sri Lankan Rupee","symbol":"Rs"},
  {"code":"NPR","name":"Nepalese Rupee","symbol":"₨"},
  {"code":"AFN","name":"Afghan Afghani","symbol":"؋"},
  {"code":"IRR","name":"Iranian Rial","symbol":"﷼"},
  {"code":"IQD","name":"Iraqi Dinar","symbol":"ع.د"},
  {"code":"SAR","name":"Saudi Riyal","symbol":"﷼"},
  {"code":"AED","name":"UAE Dirham","symbol":"د.إ"},
  {"code":"QAR","name":"Qatari Riyal","symbol":"﷼"},
  {"code":"OMR","name":"Omani Rial","symbol":"﷼"},
  {"code":"KWD","name":"Kuwaiti Dinar","symbol":"د.ك"},
  {"code":"BHD","name":"Bahraini Dinar","symbol":"ب.د"},
  {"code":"JOD","name":"Jordanian Dinar","symbol":"د.ا"},
  {"code":"ILS","name":"Israeli Shekel","symbol":"₪"},
  {"code":"TRY","name":"Turkish Lira","symbol":"₺"},

  {"code":"THB","name":"Thai Baht","symbol":"฿"},
  {"code":"VND","name":"Vietnamese Dong","symbol":"₫"},
  {"code":"IDR","name":"Indonesian Rupiah","symbol":"Rp"},
  {"code":"MYR","name":"Malaysian Ringgit","symbol":"RM"},
  {"code":"SGD","name":"Singapore Dollar","symbol":"$"},
  {"code":"PHP","name":"Philippine Peso","symbol":"₱"},
  {"code":"KRW","name":"South Korean Won","symbol":"₩"},

  {"code":"RUB","name":"Russian Ruble","symbol":"₽"},
  {"code":"UAH","name":"Ukrainian Hryvnia","symbol":"₴"},
  {"code":"PLN","name":"Polish Zloty","symbol":"zł"},
  {"code":"CZK","name":"Czech Koruna","symbol":"Kč"},
  {"code":"HUF","name":"Hungarian Forint","symbol":"Ft"},
  {"code":"RON","name":"Romanian Leu","symbol":"lei"},
  {"code":"BGN","name":"Bulgarian Lev","symbol":"лв"},
  {"code":"SEK","name":"Swedish Krona","symbol":"kr"},
  {"code":"NOK","name":"Norwegian Krone","symbol":"kr"},
  {"code":"DKK","name":"Danish Krone","symbol":"kr"},
  {"code":"ISK","name":"Icelandic Krona","symbol":"kr"},

  {"code":"ARS","name":"Argentine Peso","symbol":"$"},
  {"code":"BRL","name":"Brazilian Real","symbol":"R$"},
  {"code":"CLP","name":"Chilean Peso","symbol":"$"},
  {"code":"COP","name":"Colombian Peso","symbol":"$"},
  {"code":"MXN","name":"Mexican Peso","symbol":"$"},
  {"code":"PEN","name":"Peruvian Sol","symbol":"S/"},
  {"code":"UYU","name":"Uruguayan Peso","symbol":"$U"},
  {"code":"PYG","name":"Paraguayan Guarani","symbol":"₲"},
  {"code":"BOB","name":"Bolivian Boliviano","symbol":"Bs"},
  {"code":"DOP","name":"Dominican Peso","symbol":"RD$"},
  {"code":"JMD","name":"Jamaican Dollar","symbol":"J$"},
  {"code":"TTD","name":"Trinidad and Tobago Dollar","symbol":"TT$"},

  {"code":"FJD","name":"Fijian Dollar","symbol":"$"},
  {"code":"PGK","name":"Papua New Guinean Kina","symbol":"K"},
  {"code":"SBD","name":"Solomon Islands Dollar","symbol":"SI$"},
  {"code":"TOP","name":"Tongan Paʻanga","symbol":"T$"},
  {"code":"VUV","name":"Vanuatu Vatu","symbol":"VT"},

  {"code":"XCD","name":"East Caribbean Dollar","symbol":"EC$"},
  {"code":"BBD","name":"Barbadian Dollar","symbol":"Bds$"},
  {"code":"BSD","name":"Bahamian Dollar","symbol":"B$"},
  {"code":"BZD","name":"Belize Dollar","symbol":"BZ$"},
  {"code":"KYD","name":"Cayman Islands Dollar","symbol":"CI$"},
  {"code":"SRD","name":"Surinamese Dollar","symbol":"$"},
  {"code":"GYD","name":"Guyanese Dollar","symbol":"G$"},

  {"code":"ALL","name":"Albanian Lek","symbol":"L"},
  {"code":"MKD","name":"Macedonian Denar","symbol":"ден"},
  {"code":"RSD","name":"Serbian Dinar","symbol":"дин"},
  {"code":"GEL","name":"Georgian Lari","symbol":"₾"},
  {"code":"AMD","name":"Armenian Dram","symbol":"֏"},
  {"code":"AZN","name":"Azerbaijani Manat","symbol":"₼"},

  // Additional currencies from comprehensive list
  {"code":"AFN","name":"Afghan Afghani","symbol":"؋"},
  {"code":"AWG","name":"Aruban Florin","symbol":"ƒ"},
  {"code":"AZN","name":"Azerbaijani Manat","symbol":"₼"},
  {"code":"BIF","name":"Burundian Franc","symbol":"FBu"},
  {"code":"BMD","name":"Bermudian Dollar","symbol":"$"},
  {"code":"BND","name":"Brunei Dollar","symbol":"$"},
  {"code":"BOB","name":"Bolivian Boliviano","symbol":"Bs."},
  {"code":"BOV","name":"Bolivian Mvdol","symbol":"BOV"},
  {"code":"BRL","name":"Brazilian Real","symbol":"R$"},
  {"code":"BSD","name":"Bahamian Dollar","symbol":"$"},
  {"code":"BTN","name":"Bhutanese Ngultrum","symbol":"Nu."},
  {"code":"BWP","name":"Botswana Pula","symbol":"P"},
  {"code":"BYN","name":"Belarusian Ruble","symbol":"Br"},
  {"code":"BZD","name":"Belize Dollar","symbol":"BZ$"},
  {"code":"CDF","name":"Congolese Franc","symbol":"FC"},
  {"code":"CHE","name":"WIR Euro","symbol":"CHE"},
  {"code":"CHW","name":"WIR Franc","symbol":"CHW"},
  {"code":"CLF","name":"Chilean Unit of Account","symbol":"CLF"},
  {"code":"CLP","name":"Chilean Peso","symbol":"$"},
  {"code":"CNY","name":"Chinese Yuan","symbol":"¥"},
  {"code":"COP","name":"Colombian Peso","symbol":"$"},
  {"code":"COU","name":"Colombian Real Value Unit","symbol":"COU"},
  {"code":"CRC","name":"Costa Rican Colón","symbol":"₡"},
  {"code":"CUC","name":"Cuban Convertible Peso","symbol":"CUC"},
  {"code":"CUP","name":"Cuban Peso","symbol":"$"},
  {"code":"CVE","name":"Cape Verdean Escudo","symbol":"$"},
  {"code":"CZK","name":"Czech Koruna","symbol":"Kč"},
  {"code":"DJF","name":"Djiboutian Franc","symbol":"Fdj"},
  {"code":"DKK","name":"Danish Krone","symbol":"kr"},
  {"code":"DOP","name":"Dominican Peso","symbol":"RD$"},
  {"code":"DZD","name":"Algerian Dinar","symbol":"د.ج"},
  {"code":"EGP","name":"Egyptian Pound","symbol":"£"},
  {"code":"ERN","name":"Eritrean Nakfa","symbol":"Nfk"},
  {"code":"ETB","name":"Ethiopian Birr","symbol":"Br"},
  {"code":"EUR","name":"Euro","symbol":"€"},
  {"code":"FJD","name":"Fijian Dollar","symbol":"$"},
  {"code":"FKP","name":"Falkland Islands Pound","symbol":"£"},
  {"code":"GBP","name":"British Pound Sterling","symbol":"£"},
  {"code":"GEL","name":"Georgian Lari","symbol":"₾"},
  {"code":"GHS","name":"Ghanaian Cedi","symbol":"₵"},
  {"code":"GIP","name":"Gibraltar Pound","symbol":"£"},
  {"code":"GMD","name":"Gambian Dalasi","symbol":"D"},
  {"code":"GNF","name":"Guinean Franc","symbol":"FG"},
  {"code":"GTQ","name":"Guatemalan Quetzal","symbol":"Q"},
  {"code":"GYD","name":"Guyanese Dollar","symbol":"$"},
  {"code":"HKD","name":"Hong Kong Dollar","symbol":"$"},
  {"code":"HNL","name":"Honduran Lempira","symbol":"L"},
  {"code":"HRK","name":"Croatian Kuna","symbol":"kn"},
  {"code":"HTG","name":"Haitian Gourde","symbol":"G"},
  {"code":"HUF","name":"Hungarian Forint","symbol":"Ft"},
  {"code":"IDR","name":"Indonesian Rupiah","symbol":"Rp"},
  {"code":"ILS","name":"Israeli New Shekel","symbol":"₪"},
  {"code":"INR","name":"Indian Rupee","symbol":"₹"},
  {"code":"IQD","name":"Iraqi Dinar","symbol":"ع.د"},
  {"code":"IRR","name":"Iranian Rial","symbol":"﷼"},
  {"code":"ISK","name":"Icelandic Króna","symbol":"kr"},
  {"code":"JMD","name":"Jamaican Dollar","symbol":"J$"},
  {"code":"JOD","name":"Jordanian Dinar","symbol":"د.ا"},
  {"code":"JPY","name":"Japanese Yen","symbol":"¥"},
  {"code":"KES","name":"Kenyan Shilling","symbol":"KSh"},
  {"code":"KGS","name":"Kyrgyzstani Som","symbol":"с"},
  {"code":"KHR","name":"Cambodian Riel","symbol":"៛"},
  {"code":"KMF","name":"Comorian Franc","symbol":"CF"},
  {"code":"KPW","name":"North Korean Won","symbol":"₩"},
  {"code":"KRW","name":"South Korean Won","symbol":"₩"},
  {"code":"KWD","name":"Kuwaiti Dinar","symbol":"د.ك"},
  {"code":"KYD","name":"Cayman Islands Dollar","symbol":"$"},
  {"code":"KZT","name":"Kazakhstani Tenge","symbol":"₸"},
  {"code":"LAK","name":"Laotian Kip","symbol":"₭"},
  {"code":"LBP","name":"Lebanese Pound","symbol":"£"},
  {"code":"LKR","name":"Sri Lankan Rupee","symbol":"Rs"},
  {"code":"LRD","name":"Liberian Dollar","symbol":"$"},
  {"code":"LSL","name":"Lesotho Loti","symbol":"L"},
  {"code":"LYD","name":"Libyan Dinar","symbol":"ل.د"},
  {"code":"MAD","name":"Moroccan Dirham","symbol":"د.م."},
  {"code":"MDL","name":"Moldovan Leu","symbol":"L"},
  {"code":"MGA","name":"Malagasy Ariary","symbol":"Ar"},
  {"code":"MKD","name":"Macedonian Denar","symbol":"ден"},
  {"code":"MMK","name":"Myanmar Kyat","symbol":"K"},
  {"code":"MNT","name":"Mongolian Tugrik","symbol":"₮"},
  {"code":"MOP","name":"Macanese Pataca","symbol":"P"},
  {"code":"MRU","name":"Mauritanian Ouguiya","symbol":"UM"},
  {"code":"MUR","name":"Mauritian Rupee","symbol":"₨"},
  {"code":"MVR","name":"Maldivian Rufiyaa","symbol":"ރ"},
  {"code":"MWK","name":"Malawian Kwacha","symbol":"MK"},
  {"code":"MXN","name":"Mexican Peso","symbol":"$"},
  {"code":"MXV","name":"Mexican Investment Unit","symbol":"MXV"},
  {"code":"MYR","name":"Malaysian Ringgit","symbol":"RM"},
  {"code":"MZN","name":"Mozambican Metical","symbol":"MT"},
  {"code":"NAD","name":"Namibian Dollar","symbol":"$"},
  {"code":"NIO","name":"Nicaraguan Córdoba","symbol":"C$"},
  {"code":"NOK","name":"Norwegian Krone","symbol":"kr"},
  {"code":"NPR","name":"Nepalese Rupee","symbol":"₨"},
  {"code":"NZD","name":"New Zealand Dollar","symbol":"$"},
  {"code":"OMR","name":"Omani Rial","symbol":"﷼"},
  {"code":"PAB","name":"Panamanian Balboa","symbol":"B/."},
  {"code":"PEN","name":"Peruvian Sol","symbol":"S/"},
  {"code":"PGK","name":"Papua New Guinean Kina","symbol":"K"},
  {"code":"PHP","name":"Philippine Peso","symbol":"₱"},
  {"code":"PKR","name":"Pakistani Rupee","symbol":"₨"},
  {"code":"PLN","name":"Polish Złoty","symbol":"zł"},
  {"code":"PYG","name":"Paraguayan Guarani","symbol":"₲"},
  {"code":"QAR","name":"Qatari Riyal","symbol":"﷼"},
  {"code":"RON","name":"Romanian Leu","symbol":"lei"},
  {"code":"RSD","name":"Serbian Dinar","symbol":"дин"},
  {"code":"RUB","name":"Russian Ruble","symbol":"₽"},
  {"code":"RWF","name":"Rwandan Franc","symbol":"FRw"},
  {"code":"SAR","name":"Saudi Riyal","symbol":"﷼"},
  {"code":"SBD","name":"Solomon Islands Dollar","symbol":"SI$"},
  {"code":"SCR","name":"Seychellois Rupee","symbol":"₨"},
  {"code":"SDG","name":"Sudanese Pound","symbol":"£"},
  {"code":"SEK","name":"Swedish Krona","symbol":"kr"},
  {"code":"SGD","name":"Singapore Dollar","symbol":"$"},
  {"code":"SHP","name":"Saint Helena Pound","symbol":"£"},
  {"code":"SLL","name":"Sierra Leonean Leone","symbol":"Le"},
  {"code":"SOS","name":"Somali Shilling","symbol":"Sh"},
  {"code":"SRD","name":"Surinamese Dollar","symbol":"$"},
  {"code":"SSP","name":"South Sudanese Pound","symbol":"£"},
  {"code":"STN","name":"São Tomé and Príncipe Dobra","symbol":"Db"},
  {"code":"SVC","name":"Salvadoran Colón","symbol":"₡"},
  {"code":"SYP","name":"Syrian Pound","symbol":"£"},
  {"code":"SZL","name":"Swazi Lilangeni","symbol":"L"},
  {"code":"THB","name":"Thai Baht","symbol":"฿"},
  {"code":"TJS","name":"Tajikistani Somoni","symbol":"ЅМ"},
  {"code":"TMT","name":"Turkmenistani Manat","symbol":"T"},
  {"code":"TND","name":"Tunisian Dinar","symbol":"د.ت"},
  {"code":"TOP","name":"Tongan Paʻanga","symbol":"T$"},
  {"code":"TRY","name":"Turkish Lira","symbol":"₺"},
  {"code":"TTD","name":"Trinidad and Tobago Dollar","symbol":"TT$"},
  {"code":"TWD","name":"New Taiwan Dollar","symbol":"$"},
  {"code":"TZS","name":"Tanzanian Shilling","symbol":"TSh"},
  {"code":"UAH","name":"Ukrainian Hryvnia","symbol":"₴"},
  {"code":"UGX","name":"Ugandan Shilling","symbol":"USh"},
  {"code":"USD","name":"United States Dollar","symbol":"$"},
  {"code":"USN","name":"United States Dollar (Next day)","symbol":"USN"},
  {"code":"UYI","name":"Uruguay Peso en Unidades Indexadas","symbol":"UYI"},
  {"code":"UYU","name":"Uruguayan Peso","symbol":"$"},
  {"code":"UYW","name":"Unidad Previsional","symbol":"UYW"},
  {"code":"UZS","name":"Uzbekistan Som","symbol":"so'm"},
  {"code":"VES","name":"Venezuelan Bolívar Soberano","symbol":"Bs.S"},
  {"code":"VND","name":"Vietnamese Đồng","symbol":"₫"},
  {"code":"VUV","name":"Vanuatu Vatu","symbol":"VT"},
  {"code":"WST","name":"Samoan Tala","symbol":"T"},
  {"code":"XAF","name":"CFA Franc BEAC","symbol":"FCFA"},
  {"code":"XAG","name":"Silver","symbol":"XAG"},
  {"code":"XAU","name":"Gold","symbol":"XAU"},
  {"code":"XBA","name":"European Composite Unit","symbol":"XBA"},
  {"code":"XBB","name":"European Monetary Unit","symbol":"XBB"},
  {"code":"XBC","name":"European Unit of Account 9","symbol":"XBC"},
  {"code":"XBD","name":"European Unit of Account 17","symbol":"XBD"},
  {"code":"XCD","name":"East Caribbean Dollar","symbol":"$"},
  {"code":"XDR","name":"Special Drawing Rights","symbol":"XDR"},
  {"code":"XOF","name":"CFA Franc BCEAO","symbol":"CFA"},
  {"code":"XPD","name":"Palladium","symbol":"XPD"},
  {"code":"XPF","name":"CFP Franc","symbol":"₣"},
  {"code":"XPT","name":"Platinum","symbol":"XPT"},
  {"code":"XSU","name":"Sucre","symbol":"XSU"},
  {"code":"XTS","name":"Testing Currency Code","symbol":"XTS"},
  {"code":"XUA","name":"ADB Unit of Account","symbol":"XUA"},
  {"code":"XXX","name":"No Currency","symbol":"XXX"},
  {"code":"YER","name":"Yemeni Rial","symbol":"﷼"},
  {"code":"ZAR","name":"South African Rand","symbol":"R"},
  {"code":"ZMW","name":"Zambian Kwacha","symbol":"ZK"},
  {"code":"ZWL","name":"Zimbabwean Dollar","symbol":"$"}
]

// Create a lookup map for faster access
const currencyMap = new Map(CURRENCIES.map(currency => [currency.code, currency]))

/**
 * Get currency information by code
 * @param {string} code - Currency code (e.g., 'USD', 'NGN')
 * @returns {object|null} Currency object with code, name, symbol
 */
export const getCurrency = (code) => {
  return currencyMap.get(code?.toUpperCase()) || null
}

/**
 * Format price with currency symbol
 * @param {number|string} price - The price amount
 * @param {string} currencyCode - Currency code (e.g., 'USD', 'NGN')
 * @param {object} options - Formatting options
 * @returns {string} Formatted price string
 */
export const formatPrice = (price, currencyCode, options = {}) => {
  const {
    showCode = false, // Whether to show currency code alongside symbol
    locale = 'en-US',
    minimumFractionDigits = 2,
    maximumFractionDigits = 2
  } = options

  if (price === null || price === undefined || price === '') {
    return ''
  }

  const numPrice = typeof price === 'string' ? parseFloat(price) : price
  if (isNaN(numPrice)) {
    return ''
  }

  const currency = getCurrency(currencyCode)
  if (!currency) {
    // Fallback to code only if currency not found
    return `${currencyCode || ''} ${numPrice.toLocaleString(locale, {
      minimumFractionDigits,
      maximumFractionDigits
    })}`
  }

  const formattedNumber = numPrice.toLocaleString(locale, {
    minimumFractionDigits,
    maximumFractionDigits
  })

  if (showCode) {
    return `${currency.symbol} ${formattedNumber} ${currency.code}`
  }

  return `${currency.symbol} ${formattedNumber}`
}

/**
 * Get currency symbol by code
 * @param {string} code - Currency code
 * @returns {string} Currency symbol or code if not found
 */
export const getCurrencySymbol = (code) => {
  const currency = getCurrency(code)
  return currency ? currency.symbol : (code || '')
}

/**
 * Get currency options for select dropdowns
 * @returns {Array} Array of currency options with value and label
 */
export const getCurrencyOptions = () => {
  return CURRENCIES.map(currency => ({
    value: currency.code,
    label: `${currency.symbol} ${currency.code} - ${currency.name}`
  }))
}